export const forecastCountries = {
  countries: [
    {
      countryName: "Austria",
      countryCapitol: "Wiedeń",
      regionLocid: "ATL000001",
      domainURL: "austria.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Cypr",
      countryCapitol: "Larnaka",
      regionLocid: "CYL000001",
      domainURL: "cypr.net.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Egipt",
      countryCapitol: "Kair",
      regionLocid: "EGL000001",
      domainURL: "egipt.info.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Indie",
      countryCapitol: "New Delhi",
      regionLocid: "INL000001",
      domainURL: "indie.com.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Karaiby",
      countryCapitol: "Hawana",
      regionLocid: "KRL000001",
      domainURL: "karaiby.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Kenia",
      countryCapitol: "Nairobi",
      regionLocid: "KEL000001",
      domainURL: "kenia.info.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Maroko",
      countryCapitol: "Agadir",
      regionLocid: "MAL000001",
      domainURL: "maroko.com.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Tajlandia",
      countryCapitol: "Bangkok",
      regionLocid: "THL000001",
      domainURL: "tajlandia.com.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Tunezja",
      countryCapitol: "Hammamet",
      regionLocid: "TNL000001",
      domainURL: "tunezja.com.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Wenezuela",
      countryCapitol: "Caracas",
      regionLocid: "VEL000001",
      domainURL: "wenezuela.info.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Włochy",
      countryCapitol: "Rzym",
      regionLocid: "ITL000001",
      domainURL: "wlochy.pl/pogoda-klimat.xml",
    },
    {
      countryName: "Wyspy Kanaryjskie",
      countryCapitol: "Playa de las Americas",
      regionLocid: "CIL000001",
      domainURL: "wyspykanaryjskie.pl/pogoda-klimat.xml",
    },
  ],
};
